import { crearBolilla } from './crearBolilla';
import { crearBotonJugar } from './crearBotonJugar';
import { crearBotonBorrar } from './crearBotonBorrar';
import { crearBotonRepetir } from './crearBotonRepetir';
import { crearBotonRestar } from './crearBotonRestar';
import { crearBotonSumar } from './crearBotonSumar';
import { crearCarteles } from './crearCarteles';
import { crearDisplays } from './crearDisplays';
import { crearFichasAlfombra } from './crearFichasAlfombra';
import { crearFichasEleccion } from './crearFichasEleccion';
import { crearFondoAlfombra } from './crearFondoAlfombra';
import { crearRuleta } from './crearRuleta';
import { crearUltimosNumeros } from './crearUltimosNumeros';
import { crearValoresAlfombra } from './crearValoresAlfombra';

/**
 * Carga todos los assets del juego de la ruleta
 * @param {*} scene
 */
export function creacionElementosPrincipal(scene) {
  //scene.load.reset();

  crearFondoAlfombra(scene); //Se pone al principio por el renderizado

  crearBolilla(scene);
  crearBotonJugar(scene);
  crearBotonBorrar(scene);
  crearBotonRepetir(scene);
  crearBotonRestar(scene);
  crearBotonSumar(scene);

  crearDisplays(scene);
  crearFichasAlfombra(scene);
  crearFichasEleccion(scene);
  crearRuleta(scene);

  crearCarteles(scene); //Despues de ruleta para ver los carteles

  crearUltimosNumeros(scene);
  crearValoresAlfombra(scene);
}
